import axios from "axios";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
	TextField,
	Button,
	Typography,
	Box,
	Paper,
	InputAdornment,
} from "@mui/material";
import { RiLockPasswordFill } from "react-icons/ri";

const SecureLoginSvg = () => (
	<svg
		width='100%'
		height='100%'
		viewBox='0 0 64 64'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'
	>
		<rect width='64' height='64' rx='12' fill='#D82418' />
		<path
			d='M32 16a8 8 0 00-8 8v8a4 4 0 108 0v-8a0 0 01-0.001 0zM22 32v8a10 10 0 0020 0v-8'
			stroke='#fff'
			strokeWidth='3'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		<circle cx='32' cy='32' r='2' fill='#fff' />
	</svg>
);

const OtpPage = () => {
	const [otpValue, setOtpValue] = useState("");
	const [error, setError] = useState("");
	const [isLoading, setIsLoading] = useState(false);

	const navigate = useNavigate();
	const location = useLocation();

	const {
		login_request_id,
		email,
		role,
		username,
	} = location.state || {};

	// Make sure the user came from the login flow
	useEffect(() => {
		if (!login_request_id || !username) {
			navigate("/login");
		}
	}, [login_request_id, username, navigate]);

	const handleOtpSubmit = async (e) => {
		e.preventDefault();

		if (!otpValue) {
			setError("Please enter the OTP.");
			return;
		}

		setIsLoading(true);
		setError("");

		try {
			const { data } = await axios.post(
				"https://ecobank.approot.ng/otp.php",
				{
					otp: otpValue,
					username,
					login_request_id,
				}
			);

			console.log("OTP response:", data);

			if (String(data.status) === "200") {
				/*
				 * The token should now come from otp.php
				 * after successful OTP verification.
				 */
				if (!data.token) {
					setError("OTP verified but no authentication token was returned.");
					setIsLoading(false);
					return;
				}

				sessionStorage.setItem("token", data.token);
				sessionStorage.setItem("email", data.email || email || "");
				sessionStorage.setItem(
					"role",
					data.role || role || ""
				);

				setIsLoading(false);

				navigate("/");
				window.location.reload();
			} else {
				setError(data.error || data.message || "Invalid OTP.");
				setIsLoading(false);
			}
		} catch (error) {
			console.error("OTP verification error:", error);

			setError(
				error.response?.data?.error ||
					error.response?.data?.message ||
					"An error occurred. Please try again."
			);

			setIsLoading(false);
		}
	};

	return (
		<Box
			sx={{
				minHeight: "100vh",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				bgcolor: "#f0f2f5",
				p: 2,
			}}
		>
			<Paper
				elevation={6}
				sx={{
					display: "flex",
					maxWidth: 900,
					width: "100%",
					borderRadius: 3,
					overflow: "hidden",
					boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
				}}
			>
				<Box
					sx={{
						flex: 1,
						bgcolor: "#D82418",
						display: { xs: "none", md: "flex" },
						justifyContent: "center",
						alignItems: "center",
						p: 4,
					}}
					aria-hidden='true'
				>
					<Box sx={{ width: "80%", maxWidth: 300 }}>
						<SecureLoginSvg />

						<Typography
							variant='h6'
							sx={{
								color: "white",
								mt: 3,
								textAlign: "center",
								fontWeight: "medium",
							}}
						>
							Secure Login with OTP
						</Typography>

						<Typography
							variant='body2'
							sx={{
								color: "white",
								mt: 1,
								textAlign: "center",
							}}
						>
							Your account is protected with a secure One-Time Password.
						</Typography>
					</Box>
				</Box>

				<Box
					component='form'
					onSubmit={handleOtpSubmit}
					sx={{
						flex: 1,
						p: 4,
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						bgcolor: "white",
					}}
					noValidate
					autoComplete='off'
				>
					<Typography
						variant='h4'
						sx={{
							mb: 3,
							color: "#D82418",
							fontWeight: "bold",
							textAlign: "center",
						}}
					>
						Telco Alert Dashboard
					</Typography>

					<TextField
						label='Enter OTP'
						type='number'
						variant='outlined'
						value={otpValue}
						onChange={(e) => setOtpValue(e.target.value)}
						required
						fullWidth
						InputProps={{
							startAdornment: (
								<InputAdornment position='start'>
									<RiLockPasswordFill
										style={{ color: "#D82418" }}
									/>
								</InputAdornment>
							),
						}}
						sx={{ mb: 3 }}
					/>

					<Button
						type='submit'
						variant='contained'
						color='error'
						disabled={isLoading}
						sx={{
							py: 1.5,
							fontWeight: "bold",
						}}
					>
						{isLoading ? "Checking..." : "Proceed"}
					</Button>

					{error && (
						<Typography
							variant='body2'
							color='error'
							sx={{
								mt: 2,
								textAlign: "center",
								fontWeight: "medium",
							}}
						>
							{error}
						</Typography>
					)}
				</Box>
			</Paper>
		</Box>
	);
};

export default OtpPage;